import ItemComponent from './ItemComponent';

export default ItemComponent;
